import { render } from "./index.vue?vue&type=template&id=2d1706dc&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=2d1706dc&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1706dc"]])

export default __exports__